import { request } from './index';
const projectUrl = {
	getProjects: '/project/list',
	getMyProject: '/project/my',
	setOperationTime: (id: string) => `/project/${id}/operationTime/set`,
};

export interface IProjectProps {
	clientId: string;
	name: string;
	progressStatus: string;
}

export interface IGetProjectProps {
	pagination: IPagination;
	list: IProject[];
}

export const getProjects = (
	params: IProjectProps,
	pagination?: IPagination,
): Promise<IGetProjectProps> => {
	return new Promise((resolve) => {
		request(projectUrl.getProjects, { body: params, pagination }).then((res) => {
			resolve((res as unknown) as IGetProjectProps);
		});
	});
};

export interface IGetMyProjectsProps {
	project: IProject;
	client: ISplitEnd;
	team: {
		state: 0 | 1;
	};
	teamMember: {
		state: 0 | 1;
	};
}
export const getMyProjects: () => Promise<IGetMyProjectsProps[]> = () => {
	return new Promise((resolve) => {
		request(projectUrl.getMyProject).then((res) => {
			resolve((res as unknown) as IGetMyProjectsProps[]);
		});
	});
};

export const setOperationTime: (projectId: string) => Promise<unknown> = (projectId) => {
	return new Promise((resolve) => {
		request(projectUrl.setOperationTime(projectId), {}, 'get').then((res) => {
			resolve(res);
		});
	});
};
